import { HandType } from "backend/src/common/types/roomState";
import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

export const setHandType = (handType: HandType) => {
  const socket = getOrCreateSocket();
  socket.emit("setHandType", store.currentRoom, handType);
};
